import type { ImgHTMLAttributes, ReactElement, SyntheticEvent } from 'react';

import { Skeleton } from '@rango-dev/whale';
import React, { useLayoutEffect, useRef, useState } from 'react';

export function Image(props: ImgHTMLAttributes<HTMLImageElement>): ReactElement {
  const { onLoad, onError, ...rest } = props;
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  const handleLoad = (event: SyntheticEvent<HTMLImageElement>) => {
    setLoaded(true);
    onLoad?.(event);
  };

  const handleError = (event: SyntheticEvent<HTMLImageElement>) => {
    setLoaded(true);
    onError?.(event);
  };

  /*
   * Cached images can fire `load` before React attaches its listener, leaving
   * the skeleton stuck. After commit (pre-paint), reconcile from `.complete`
   * — and reset on src change so a non-cached new src shows the skeleton again.
   */
  useLayoutEffect(() => {
    setLoaded(imgRef.current?.complete ?? false);
  }, [rest.src]);

  return (
    <Skeleton loading={!loaded}>
      <img ref={imgRef} {...rest} onLoad={handleLoad} onError={handleError} />
    </Skeleton>
  );
}
